import { Injectable } from '@angular/core';
import { LookAndFeelWebView } from 'src/models/LookAndFeelWebView';
import { dictionaryBooking } from 'src/models/languageBooking';
import { ResponseCompanies } from './incadea/incadea-interfaces/responses/ResponseCompanies.interface';
@Injectable({
    providedIn: 'root',
  })
  export class incadeaChileConfig {

    adressGeelyIncadea:string= "https://www.geely.cl/agendamiento-terceros"
    arrayGeely: ResponseCompanies [] = 
    [
      {
        Id: "",
        Description:"AUTOMOTORA ALAMEDA SAN FERNANDO - GEELY",
        Name:"I Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTRIZ MIRANDA ANTOFAGASTA - GEELY",
        Name:"II Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"CARMONA - GEELY",
        Name:"IV Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTORA MACH VIÑA DEL MAR SAN ANTONIO - GEELY",
        Name:"V Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTORA ALAMEDA RANCAGUA - GEELY",
        Name:"VI Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTRIZ ALAMEDA CURICÓ - GEELY",
        Name:"VII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL TALCA",
        Name:"VII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL CONCEPCIÓN - GEELY",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL LOS ANGELES - GEELY",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL LOS ÁNGELES (DYP)",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL TEMUCO SAN MARTIN - GEELY",
        Name:"IX Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTRIZ ARAUCO OSORNO - GEELY",
        Name:"X Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL ALESSANDRI (DYP)",
        Name:"Region Metro",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL ANANÍAS (DYP)",
        Name:"Region Metro",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL QUILICURA (DYP)",
        Name:"Region Metro",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"POMPEYO CARRASCO ZÚRICH - GEELY",
        Name:"Region Metro",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"POMPEYO CARRASCO RED CUBE",
        Name:"Region Metro",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"POMPEYO CARRASCO PLAZA OESTE - GEELY",
        Name:"Region Metro",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"POMPEYO CARRASCO TOBALABA",
        Name:"Region Metro",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL VICUÑA MACKENNA - GEELY",
        Name:"Region Metro",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
    ]
    adressSubaruIncadea:string= "https://www.subaru.cl/agenda-tu-servicio"
    arraySubaru: ResponseCompanies [] = 
    [
      {
        Id: "",
        Description:"AUTOMOTRIZ YUTRONIC DAMANIC",
        Name:"I Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTRIZ YUTRONIC DAMANIC",
        Name:"I Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTRIZ MIRANDA ANTOFAGASTA - SUBARU",
        Name:"II Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"CALLEGARI AUTOMOTRIZ COPIAPO - SUBARU",
        Name:"III Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"CALLEGARI AUTOMOTRIZ LA SERENA - SUBARU",
        Name:"IV Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"CALLEGARI AUTOMOTRIZ OVALLE - SUBARU",
        Name:"IV Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTORA MACH VIÑA DEL MAR SAN ANTONIO - SUBARU",
        Name:"V Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTORA MACH VALPARAÍSO - SUBARU",
        Name:"V Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTRIZ ALAMEDA RANCAGUA - SUBARU",
        Name:"VI Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTORA BALADRÓN - SUBARU",
        Name:"VII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"FERNANDO GOMEZ Y CIA - SUBARU",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL ALESSANDRI - DYP",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL CHILLAN 5 DE ABRIL - SERVI",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL LOS ANGELES - DYP",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL PRAT - SERVI",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"EUROMOTORS TEMUCO -SUBARU",
        Name:"IX Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL TEMUCO - DYP",
        Name:"IX Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL TEMUCO SAN MARTIN - SERVI",
        Name:"IX Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SERVIMAQ PUERT MONTT",
        Name:"X Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTRÍZ VARONA LTDA. - SUBARU",
        Name:"XI Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
       {
        Id: "",
        Description:"AUTOMOTORA GUIC LTDA",
        Name:"XI Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTORA GUIC LTDA",
        Name:"XI Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
       {
        Id: "",
        Description:"AUTOMOTORA GUIC LTDA",
        Name:"XII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTORA GUIC LTDA",
        Name:"XII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTORA GUIC LTDA",
        Name:"XII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"SALAZAR ISRAEL VALDIVIA - SERVI",
        Name:"XIV Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"TECNOSUR VALDIVIA - SUBARU",
        Name:"XIV Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"AUTOMOTORA VALP",
        Name:"Metropolitana",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"INDUMOTORA ONE LA DEHESA",
        Name:"Metropolitana",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"INDUMOTORA ONE SANTIAGO",
        Name:"Metropolitana",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"LARRAÍN Y VALDÉS FCO BILBAO",
        Name:"Metropolitana",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"LARRAÍN Y VALDÉS SANTA ELENA",
        Name:"Metropolitana",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"LARRAÍN Y VALDÉS VIC MACKENNA",
        Name:"Metropolitana",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"POMPEYO CARRASCO ZÚRICH",
        Name:"Metropolitana",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
        },
        {
          Id: "",
          Description: "SERGIO ESCOBAR SPA",
          Name: "Metropolitana",
          Locations: [
            {
              Id: "",
              Code: "",
              Description: "",
              Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
              }
            }
          ]
        }
    ]
    adressDfskIncadea:string= "https://www.dfsk.cl/agendamiento-terceros"
    arrayDfsk: ResponseCompanies [] = 
    [
      {
        Id: "",
        Description:"Automotriz Miranda Antofagasta",
        Name:"II Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Automotriz Miranda Calama",
        Name:"II Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Callegari Automotriz Copiapó",
        Name:"III Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Callegari Automotriz La Serena",
        Name:"IV Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Callegari Automotriz Ovalle",
        Name:"IV Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Automotora Mach Valparaiso",
        Name:"V Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },{
        Id: "",
        Description:"Automotora Mach Viña del Mar",
        Name:"V Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Automotora Alameda Rancagua",
        Name:"VI Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Salazar Israel Alessandri - DyP",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Salazar Israel Chillan 5 de Abril - Servi",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Salazar Israel Los Angeles - DyP",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Salazar Israel Prat - Servi",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Copelec Automotriz Chillán",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Fernando Gomez Concepción",
        Name:"VIII Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Salazar Israel Temuco - DyP",
        Name:"IX Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Salazar Israel Temuco San Martin - Servi",
        Name:"IX Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Automotriz Tecnosur Valdivia",
        Name:"XIV Region",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Larrain y Valdés Santa Elena",
        Name:"Metropolitana",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Larrain y Valdés Vicuña Mackenna",
        Name:"Metropolitana",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Pompeyo Carrasco Mall Plaza Oeste",
        Name:"Metropolitana",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Pompeyo Carrasco Mall Plaza Tobalaba",
        Name:"Metropolitana",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
      {
        Id: "",
        Description:"Pompeyo Carrasco Zurich",
        Name:"Metropolitana",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      }
    ]
    adressDercoIncadea:string= "https://serviciotecnico.dercocenter.cl/ReservaHora.aspx"
    arrayDerco: ResponseCompanies [] = 
    [
      {
        Id: "",
        Description:"La Cabaña",
        Name:"Derco 1",
        Locations: [
            {
              Id: "",
              Code: "",
              Description:"",
              Address: {
                  Type: "",
                  PostalCode: "",
                  Street: "",
                  City: "",
                  Country: "",
                  GeoLatitude: "",
                  GeoLongitude: ""
              }
            }
        ]
      },
    {
      Id: "",
      Description:"Yusic - Arica",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Yusic - Mall Arica",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Yusic Iquique (Zona Franca)",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Yusic - Antofagasta - Pérez Zujovic",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Yusic - Calama",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Autocentro Nicolás - Copiapó",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Aspillaga Hornauer - Coquimbo",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Aspillaga Hornauer Coquimbo Santa Ester",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Valentini - La Serena (Balmaceda)",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Aspillaga Hornauer - Ovalle",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Suzuval - Concón",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Suzuval - La Calera",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Aspillaga Hornauer - Quillota",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Aspillaga Hornauer - El Belloto",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Suzuval - San Antonio",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Suzuval - Valparaíso (Salón Suzuki-SSTT)",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Aspillaga Hornauer - Viña del Mar - Quillota 766",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Suzuval - Viña del Mar - 5 Oriente 204",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Anfruns Motors - Rancagua",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Pedro Cumsille - San Fernando - Manuel Rodríguez",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Jesús Pons - Curicó - Km 191",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Jesús Pons - Linares",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Automotora Arauco - Talca",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"DeCar - Temuco Casa Matriz",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Automotriz Berrios SPA - Castro (Pedro Montt)",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Hernan Toirkens y Cía.Ltda. - Frutillar",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Automotriz Berrios SPA - Puerto Varas",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Recasur - Coyhaique",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    
    {
      Id: "",
      Description:"Recasur - Punta Arenas",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Nuevos - DYP - San Bernardo",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Patricio Hidalgo - Estación Central",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Automotora Bilbao - La Reina",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Anfruns Motors Maipú",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Dumay - Vitacura",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Dercocenter Departamental",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Dercocenter Plaza Oeste ",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Dercocenter Movicenter ",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Autum - Las Condes - Av. Ossa con Bilbao",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Dercocenter Open Plaza Kennedy  - Costado Parque Arauco",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Suzuval Melipilla",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Dercocenter Plaza Tobalaba",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Nuevos Plaza Sur - San Bernardo",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Dercocenter Carrera",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Dercocenter Gran Avenida",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"DercoCenter Servicio Técnico Pajaritos Maipú",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Automotriz Berrios SPA - Valdivia",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Sergio Escobar - Concepción - (O´Higgins 36)",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Sergio Escobar - Paicaví",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Sergio Escobar - Los Ángeles - Avda. Las industrias",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Sergio Escobar - Chillán -(O´Higgins)",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Sergio Escobar Spa - Osorno",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Dercocenter Errazuriz - Buin/Paine",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Ansa - Huechuraba",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Cerda y Tagle Cia LTDA",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Automotriz Berrios SPA - Puerto Montt - Santa María 395",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Dumay DYP - Huechuraba",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Dercocenter DYP - La Florida",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Autum - DYP - La Reina",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Chamy - Ñuñoa",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Automotora Bilbao - Providencia - Suzuki",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Sermaco Automotriz - Providencia",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Valderrama - Santiago",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
      ]
    },
    {
      Id: "",
      Description:"Dercocenter - Autofix",
      Name:"Derco 1",
      Locations: [
          {
            Id: "",
            Code: "",
            Description:"",
            Address: {
                Type: "",
                PostalCode: "",
                Street: "",
                City: "",
                Country: "",
                GeoLatitude: "",
                GeoLongitude: ""
            }
          }
        ]
      }
    ]
  }
